"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var CheckIcon = function (props) { return (react_1["default"].createElement("svg", __assign({}, {
    "aria-hidden": true,
    height: 16,
    width: 12,
    viewBox: "0 0 12 16",
    fill: "#FFFFFF",
    style: {
        display: "inline-block",
        verticalAlign: "text-top"
    }
}, props),
    react_1["default"].createElement("path", { fillRule: "evenodd", d: "M12 5.5l-8 8-4-4L1.5 8 4 10.5 10.5 4 12 5.5z" }))); };
exports["default"] = CheckIcon;
